module.exports = __webpack_public_path__ + "static/media/icon-check-circle.45ca377a.svg";